import { Link } from 'react-router-dom';
import { Folder, LayoutGrid } from 'lucide-react';
import { useWorkspace } from '../contexts/WorkspaceContext';
import { AREA_ICONS, isVisibleSection } from '../lib/areas';
import WidgetCard from '../components/WidgetCard';

// Each business area, and how much of it is answered.
export default function AreaOverview() {
  const { sections } = useWorkspace();
  const areas = sections.filter(isVisibleSection);
  if (areas.length === 0) return null;

  return (
    <WidgetCard title="Business areas" icon={LayoutGrid}>
      <div className="grid gap-2 sm:grid-cols-2 lg:grid-cols-4">
        {areas.map(section => {
          const Icon = AREA_ICONS[section.id] ?? Folder;
          const pct = section.progress?.total ? Math.round(section.progress.pct) : null;
          return (
            <Link
              key={section.id}
              to={`/workspace/${section.id}`}
              className={`border border-softgrey rounded-lg p-3 hover:border-brand/40 transition-colors ${section.enabled ? '' : 'opacity-60'}`}
            >
              <span className="flex items-center gap-2 text-[13px] font-medium text-graphite">
                <Icon className="w-4 h-4 text-coolslate shrink-0" />
                <span className="truncate">{section.name}</span>
                {section.notification && <span className="w-1.5 h-1.5 rounded-full bg-signal shrink-0" />}
              </span>
              {pct !== null && (
                <span className="mt-2 block h-1.5 rounded-full bg-softgrey overflow-hidden">
                  <span className="block h-full bg-brand" style={{ width: `${pct}%` }} />
                </span>
              )}
            </Link>
          );
        })}
      </div>
    </WidgetCard>
  );
}
